import { createContext } from 'react';

/** Optional inline action rendered on a toast (e.g. "Undo"). Cheap, backward-compatible
 *  extension: every existing `toast('message')` call site is unaffected. */
export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastOptions {
  durationMs?: number;
  pauseOnInteraction?: boolean;
  onDismiss?: () => void;
}

export type ToastFn = (msg: string, action?: ToastAction, options?: ToastOptions) => () => void;

export const ToastContext = createContext<ToastFn | null>(null);
